import { ProductState } from 'store/product/types';

const resetOPPlusContentReducer = (state: ProductState) => {
  state.OPPlustContent = undefined;
};

export default resetOPPlusContentReducer;
